export default __webpack_public_path__ + "static/media/large.da3458d9.jpg";